<!--箱子明细-->
<template>
    <div>
        <div class="search-ctn" style="padding-top: 0; padding-left: 0px; padding-right: 10px">
            <div class="search-name">箱子编码：{{ box.Code }}</div>
            <div class="search-name">箱子名称：{{ box.Name }}</div>
            <div class="search-name">商品种类：{{ box.TypeCount }}</div>
            <div class="search-name">货物总数：{{ box.GoodsCount }}</div>
        </div>
        <div class="section-title">商品明细</div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="box.GoodsList"
                border=""
                style="width: 100%; margin-bottom: 30px"
                min-height="530px"
                show-summary
                :summary-method="getSummaries"
            >
                <el-table-column  show-overflow-tooltip label="汽配编码" prop="APCode"> </el-table-column>
                <el-table-column show-overflow-tooltip prop="GoodsName" label="汽配名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="AutoSerise" label="使用车型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Count" label="数量">
                    <template slot-scope="scope">
                         <span v-if="scope.row.Count == 0">-</span>
                         <el-link v-else type="primary" :underline="false" style="justify-content: left;"
                            @click="showLabelData(scope.row)">{{ scope.row.Count }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Unit" label="单位"></el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" title="标签数据" :visible.sync="labelDatasVisible" width="800px"
            append-to-body>
            <div class="dialog-content" v-if="labelDatasVisible">
                <boxLabelDatas :goodsData="goodsData"  @closeDialog="labelDatasVisible = false">
                </boxLabelDatas>
            </div>
        </el-dialog>        
    </div>
</template>
<script>
import boxLabelDatas from '@/components/business/goods/boxLabelDatas';
export default {
    name: 'boxDetail',
    props: { BoxId: String },
    components:{boxLabelDatas},
    data() {
        return {
            loading: true,
            box: {
                Code: '',
                Name: '',
                TypeCount: 0,
                GoodsCountL: 0,
                GoodsList: []
            },
            labelDatasVisible:false,
            goodsData:{}
        };
    },
    mounted(){
        this.GetBoxDetail();
    },
    methods: {
        GetBoxDetail() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpBoxes/GetBoxDetail',
                    data: {
                        BoxId: that.BoxId
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        let data = res.data;
                        that.box.Code = data.Code;
                        that.box.Name = data.Name;
                        that.box.GoodsCount = data.GoodsCount;
                        that.box.TypeCount = data.TypeCount;
                        that.box.GoodsList = data.GoodsList;
                    } else that.$util.successMsg(res.errmsg);
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            if(columns.length==0||data.length==0||data.length==undefined)
                   return sums;
            columns.forEach((column, index) => {
                if (column.property == 'Count') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return sums;
        },
        showLabelData(row){
            let that=this;
            that.goodsData={
                APCode:row.APCode,
                GoodsName:row.GoodsName,
                AutoSerise:row.AutoSerise,
                Count:row.Count,
                BoxId:that.BoxId,
                GoodsId:row.GoodsId
            }
            that.labelDatasVisible=true;
        }
    },
};
</script>
<style lang="less" scoped>
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
</style>
